import { useSearchParam } from "./use-search-param";

export const useShopUrl = () => {
  const shop = useSearchParam("shop");

  if (!shop) {
    return null;
  }

  return shop.replace("https://", "").replace("www.", "");
};
